import React, { useState } from "react";

// Material-UI
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";

// Components
import Gap from "../../../components/Gap";

// Router
// import { useHistory } from "react-router-dom";
import DialogAlamatTersimpan from "./DialogAlamatTersimpan";
import DialogFormAlamat from "./DialogFormAlamat";
import { useData } from "../../../components/firebase/DataProvider";

function DialogPilihAlamat({ open, title, type, handleClose, addToCart, submitting }) {
  const [dialogPilihAlamat, setDialogPilihAlamat] = useState({
    open: false,
  });
  const [dialogFormhAlamat, setDialogFormAlamat] = useState({
    open: false,
  });
  const { profil } = useData();
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        style={{
          textAlign: "center",
        }}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>
          {type === "cart" ? "Pilih Alamat!" : "Gagal!"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {type === "info" ? (
              <>"Mohon Maaf, Saat ini Tokorame tidak menerima pesanan baru"</>
            ) : null}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {type === "cart" ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
              }}
            >
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => setDialogFormAlamat({ open: true })}
                style={{
                  textTransform: "capitalize",
                }}
              >
                Input Alamat Baru
              </Button>
              <Gap height={8} />
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                disabled={!profil?.alamat_utama}
                onClick={() => setDialogPilihAlamat({ open: true })}
                style={{
                  textTransform: "capitalize",
                }}
              >
                Pilih Alamat Tersimpan
              </Button>
            </div>
          ) : (
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleClose}
              style={{
                textTransform: "capitalize",
              }}
            >
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <DialogAlamatTersimpan
        openTesimpan={dialogPilihAlamat.open}
        closeTersimpan={() => setDialogPilihAlamat({ open: false })}
        addToCart={addToCart}
        submitting={submitting}
      />
      <DialogFormAlamat
        openForm={dialogFormhAlamat.open}
        closeForm={() => setDialogFormAlamat({ open: false })}
        addToCart={addToCart}
      />
    </>
  );
}

export default DialogPilihAlamat;
